import { useModalStore } from "@/stores/modalStore";
import { modalRegistry } from "./modalRegistry";

export function ModalHost() {
  const modals = useModalStore((s) => s.modals);

  return (
    <>
      {Object.entries(modalRegistry).map(([key, Modal]) => {
        if (!modals[key as keyof typeof modals]?.open) return null;
        return <Modal key={key} />;
      })}
    </>
  );
}
